export default class VideoPlayer extends Core.Component {
  constructor(el, context) {
    super(el, context);

    const videoEl = el.querySelector('[data-video]');

    this._video = Core.Media.createVideo(videoEl, this.data.type);
  }

  /**
   * Play the video and dispatch video-related events based on resolve/reject from Promise
   * @public
   */
  play() {
    this._video.play();
  }

  /**
   * Pause the video
   * @public
   */
  pause() {
    this._video.pause();
  }

  /**
   * Unload the video on unmount
   */
  onDismount() {
    this._video.unload();
  }
}
